import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hebergement : [],
  cars : []
};

export const myAnnouncesSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    hebergements:(state, action)=>{
      state.hebergement = action.payload
    },
  removeHebergement : (state, action)=>{
    state.hebergement = state.hebergement.filter(function(value, index, arr){ 
      return index > action.payload;
  });
  },
    },
});
export const { hebergements,removeHebergement} = myAnnouncesSlice.actions;

export default myAnnouncesSlice.reducer;
